var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"edge drawing"},[_c('line',{staticClass:"curve",attrs:{"x1":_vm.start.x,"y1":_vm.start.y,"x2":_vm.end.x,"y2":_vm.end.y}}),_c('path',{staticClass:"arrow",attrs:{"d":_vm.getArrowPath}})])}
var staticRenderFns = []

export { render, staticRenderFns }